import EdDrawer from './src/EdDrawer.vue'

/* istanbul ignore next */
EdDrawer.install = function (Vue) {
  Vue.component(EdDrawer.name, EdDrawer)
}

export default EdDrawer
